import { Roles } from "@shared/Roles";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { remult } from "remult";
import { useUser } from "../../contexts/UserProvider";
import "./Permissions.scss";
import ManagersTable from "../tables/managers-table";

export const PermissionPage = () => {
  const navigate = useNavigate();
  const { currentUser } = useUser();

  useEffect(() => {
    if (!remult.isAllowed(Roles.SuperAdmin)) navigate("/volunteers");
  }, [currentUser?.id]);

  return <div className="permissions-container">
    <ManagersTable />
  </div>;
};
